import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	status: string | null;
	assignees: string[] | null;
	milestoneId: string | null;
	priority: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	pageSize: 5,
	status: null,
	assignees: null,
	milestoneId: null,
	priority: null,
};

const portalTimeline = createSlice({
	name: 'portalTimeline',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setStatus: (state, action: PayloadAction<{ status: string | null }>) => {
			state.status = action.payload.status;
			state.page = initialState.page;
		},
		setAssignees: (state, action: PayloadAction<{ assignees: string[] | null }>) => {
			state.assignees = action.payload.assignees;
			state.page = initialState.page;
		},
		setMilestoneId: (state, action: PayloadAction<{ milestoneId: string | null }>) => {
			state.milestoneId = action.payload.milestoneId;
			state.page = initialState.page;
		},
		setPriority: (state, action: PayloadAction<{ priority: string | null }>) => {
			state.priority = action.payload.priority;
			state.page = initialState.page;
		},
		resetPortalTimeline: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setStatus,
	setAssignees,
	setMilestoneId,
	setPriority,
	resetPortalTimeline,
} = portalTimeline.actions;

export default portalTimeline.reducer;
